import type {LanguageKey} from '../config/LanguageConfig';
import {availableLanguages, defaultLanguage} from '../config/LanguageConfig';
import redirectTo from './RedirectUtil';

/**
 * Function to get the default language for the app
 *
 * First check if a locale  is already set in the app
 * then fall back to navigator language
 *
 * @param currentLocale
 * @returns {*}
 */
export const getDefaultLanguage: LanguageKey = currentLocale => {
   if (!currentLocale) {
      // Check if local is set in the app, if not use the browser language

      const foundLanguage = navigator.language.substring(0, 2).toLowerCase();

      if (availableLanguages.indexOf(foundLanguage) < 0) {
         // Web browser language is not supported, fall back to default one
         return defaultLanguage;
      } else {
         // Web browser language supported, return it
         return foundLanguage;
      }
   } else {
      // Language already in app, check if supported

      if (availableLanguages.indexOf(currentLocale) < 0) {
         // Not supported, fall back to default one
         return defaultLanguage;
      } else {
         // Supported, return it
         return currentLocale;
      }
   }
};

export const bilComLanguages = ['en', 'de', 'fr'];

export function getBilComLanguage(language: LanguageKey): LanguageKey {
   if (bilComLanguages.indexOf(language) !== -1) {
      return language;
   } else {
      return defaultLanguage;
   }
}

export const handleLanguageChange = (props, lang, setLoading) => {

   const { language, history } = props;
   const urlPath = window.location.pathname.replace(`/sign/${language}/`, "");

   setLoading(true)
   redirectTo(history, `/${lang.label.toLowerCase()}/${urlPath}`)
}

export const handleLanguageChangeWithGetInfo = (props, lang, setLoading, getPaymentInfo) => {

   const { paymentInfo } = props;

   getPaymentInfo(paymentInfo.paymentRef, lang)
   .then(() => setLoading(true))
   .catch((error) => console.log(error))
   .finally(() => handleLanguageChange(props, lang, setLoading))
}

